export default "__VITE_ASSET__7b2f4f8f__"